<template>
  <div>
    <table style="margin: 30px auto; width: 2328px;" border="1" cellspacing="0" border-color="#29282C">
        <tr style="font-weight: bold; color: #000; font-size: 26px; text-align: center; line-height: 60px; height: 60px">
            <td style="width: 170px;">服务类型</td>
            <td style="width: 210px;">SDK名称</td>
            <td style="width: 410px;">服务内容</td>
            <td style="width: 330px;">服务方式</td>
            <td style="width: 330px;">共享个人信息字段</td>
            <td style="width: 458px;">SDK服务提供商安全能力描述</td>
            <td style="width: 420px;">SDK官网</td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">定位服务</td>
            <td style="width: 210px;">百度地图</td>
            <td style="width: 410px;">提供用户位置服务，帮助用户发布<br/>信息时定位位置</td>
            <td style="width: 330px;">嵌入该SDK，SDK将c个人<br />信息</td>
            <td style="width: 330px;">设备MAC地址、唯一设备<br />识别码、位置信息</td>
            <td style="width: 458px;">通过网络安全等级保护测评，ISO27001<br />信息安全管理体系认证和ISO27018云隐<br />保护认证</td>
            <td style="width: 420px; color:#6C63B9 "><a href="http://lbsyun.baidu.com/" style="color: #6C63B9 ">http://lbsyun.baidu.com/</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">认证服务</td>
            <td style="width: 210px;">阿里芝麻认证SDK</td>
            <td style="width: 410px;">提供实名认证功能</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">设备MAC地址</td>
            <td style="width: 458px;">通过众多国际和国内的安全认证，如已<br />通过ISO/IEC27001:2013信息安全认<br />证、网络安全等级保护认证、ISO 27001<br />信息安全管理体系认证等，以业界先进的<br />解决方案充分保障信息安全。</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://zhima.alipay.com/index.htm" style="color: #6C63B9 ">https://zhima.alipay.com/index.htm</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">社交服务</td>
            <td style="width: 210px;">QQ SDK</td>
            <td style="width: 410px;">支持QQ登录、帮助用户分享内容至<br />第三方应用</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">无</td>
            <td style="width: 458px;">通过国家网络安全等级保护（三级）<br />测评和备案</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://wiki.open.qq.com/wiki/QQ%E7%94%A8%E6%88%B7%E8%83%BD%E5%8A%9B" style="color: #6C63B9 ">https://wiki.open.qq.com/wiki/<br />QQ%E7%94%A8%E6%88%B7%E<br />8%83%BD%E5%8A%9B</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">社交服务</td>
            <td style="width: 210px;">微博SDK</td>
            <td style="width: 410px;">支持微博登录、帮助用户分享内容至<br />第三方应用</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">无</td>
            <td style="width: 458px;">通过国家网络安全等级保护（三级）<br />测评和备案</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://open.weibo.com/" style="color: #6C63B9 ">https://open.weibo.com/</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">社交服务</td>
            <td style="width: 210px;">微信SDK</td>
            <td style="width: 410px;">支持微信分享、微信支付、帮助用户<br />分享内容至第三方应用</td>
            <td style="width: 330px;">嵌入该SDK</td>
            <td style="width: 330px;">无</td>
            <td style="width: 458px;">在合理的安全水平内使用各种安全保护<br />措施以保障信息的安全。例如，使用加<br />密技术（例如，TLS、SSL）、匿名化处<br />理等手段来保护个人信息。</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://open.weixin.qq.com/" style="color: #6C63B9 ">https://open.weixin.qq.com/</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">数据分析服务</td>
            <td style="width: 210px;">数美</td>
            <td style="width: 410px;">反作弊</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">设备MAC地址、唯一设备识别<br />码、位置信息</td>
            <td style="width: 458px;">获得ISO27001信息安全管理体系认证</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://www.ishumei.com/" style="color: #6C63B9 ">https://www.ishumei.com/</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">数据分析服务</td>
            <td style="width: 210px;">友盟统计</td>
            <td style="width: 410px;">推广统计和效果分析</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">设备MAC地址、唯一设备识别<br />码、位置信息</td>
            <td style="width: 458px;">获得ISO27001信息安全管理体系认证</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://www.ishumei.com/" style="color: #6C63B9 ">https://www.ishumei.com/</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">数据分析服务</td>
            <td style="width: 210px;">数字联盟</td>
            <td style="width: 410px;">提供终端有效性识别的移动安全技术术服务，其可信id服务，能够解决产品推广过程中数据不透明，以及刷单，刷量等恶意行为，帮助开发者甄别推广渠道质量，过滤无效数据</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">设备MAC地址、唯一设备识别<br />码、位置信息</td>
            <td style="width: 458px;">获得ISO27001信息安全管理体系认证</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://www.ishumei.com/" style="color: #6C63B9 ">https://www.ishumei.com/</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">数据分析服务</td>
            <td style="width: 210px;">Firebase</td>
            <td style="width: 410px;">推广统计和效果分析</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">设备MAC地址、唯一设备识别码</td>
            <td style="width: 458px;">采取去标识化处理</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://firebase.google.cn/" style="color: #6C63B9 ">https://firebase.google.cn/</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">数据分析服务</td>
            <td style="width: 210px;">Appsflyer</td>
            <td style="width: 410px;">推广统计和效果分析</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">设备MAC地址、唯一设备识别码</td>
            <td style="width: 458px;">采取去标识化处理</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://www.appsflyer.com/cn/" style="color: #6C63B9 ">https://www.appsflyer.com/cn/</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">推送服务</td>
            <td style="width: 210px;">华为推送</td>
            <td style="width: 410px;">提供华为手机推送</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">唯一设备识别码</td>
            <td style="width: 458px;">持有云安全CSA STAR 金牌认<br />证,ISO27001信息安全管理体系认证，网<br />络安全登记保护</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://developer.huawei.com/consumer/cn/hms" style="color: #6C63B9 ">https://developer.huawei.com/<br />consumer/cn/hms</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">推送服务</td>
            <td style="width: 210px;">VIVO推送</td>
            <td style="width: 410px;">提供VIVO手机推送</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">唯一设备识别码、位置信息</td>
            <td style="width: 458px;">采取去标识化处理</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://dev.vivo.com.cn/openAbility/
pushNews" style="color: #6C63B9 ">https://dev.vivo.com.cn/openAbility/<br />pushNews</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">推送服务</td>
            <td style="width: 210px;">小米推送</td>
            <td style="width: 410px;">提供推送消息</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">唯一设备识别码、位置信息</td>
            <td style="width: 458px;">采取去标识化处理</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://dev.mi.com/console/appservice/push.html" style="color: #6C63B9 ">https://dev.mi.com/console/<br />appservice/push.html</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">推送服务</td>
            <td style="width: 210px;">个推SDK</td>
            <td style="width: 410px;">提供推送消息</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">唯一设备识别码、位置信息</td>
            <td style="width: 458px;">采取去标识化处理</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://www.getui.com/push" style="color: #6C63B9 ">https://www.getui.com/push</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">推送服务</td>
            <td style="width: 210px;">极光推送</td>
            <td style="width: 410px;">提供推送消息</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">唯一设备识别码、位置信息</td>
            <td style="width: 458px;">采取去标识化处理</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://www.jiguang.cn/push" style="color: #6C63B9 ">https://www.jiguang.cn/push</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">推送服务</td>
            <td style="width: 210px;">OPPO推送</td>
            <td style="width: 410px;">提供推送消息</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">唯一设备识别码、位置信息</td>
            <td style="width: 458px;">采取去标识化处理</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://push.oppo.com/" style="color: #6C63B9 ">https://push.oppo.com/</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">问题追踪服务</td>
            <td style="width: 210px;">Bugly</td>
            <td style="width: 410px;">提供App稳定性监控，崩溃上报，帮助<br />开发者快速发现并解决崩溃;</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">设备MAC地址、唯一设备<br />识别码</td>
            <td style="width: 458px;">采取去标识化处理</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://bugly.qq.com/v2/index" style="color: #6C63B9 ">https://bugly.qq.com/v2/index</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">效果服务</td>
            <td style="width: 210px;">商汤SDK</td>
            <td style="width: 410px;">人脸识别和美颜</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">无</td>
            <td style="width: 458px;">采取去标识化处理</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://www.sensetime.com/?renqunyouhua=390005" style="color: #6C63B9 ">https://www.sensetime.com/?renqun<br />_youhua=390005</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">效果服务</td>
            <td style="width: 210px;">即构</td>
            <td style="width: 410px;">多路音视频服务</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">无</td>
            <td style="width: 458px;">对用户信息进行加密等安全措施<br />确保信息安全</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://www.zego.im/" style="color: #6C63B9 ">https://www.zego.im/</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">验证服务</td>
            <td style="width: 210px;">极验</td>
            <td style="width: 410px;">提供一键手机号验证登录服务</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">设备MAC地址、唯一设备识别<br />码、应用列表、手机号码、位<br />置信息</td>
            <td style="width: 458px;">信息系统等级保护第三级、ISO 27001信<br />息安全管理体系认证</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://www.zego.im/" style="color: #6C63B9 ">https://www.zego.im/</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">语音识别服务</td>
            <td style="width: 210px;">讯飞</td>
            <td style="width: 410px;">为用户提供文字转语音功能服务</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">无</td>
            <td style="width: 458px;">通过公安部网络安全等级保护三级认<br />证，获得ISO27000认证</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://www.xfyun.cn/" style="color: #6C63B9 ">https://www.xfyun.cn/</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">支付服务</td>
            <td style="width: 210px;">微信支付</td>
            <td style="width: 410px;">为用户充值提供快捷支付功能</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">设备MAC地址</td>
            <td style="width: 458px;">采取去标识化处理</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://pay.weixin.qq.com/index.php/core/home/login?return_url=%2F" style="color: #6C63B9 ">https://pay.weixin.qq.com/index.php/core/<br />home/login?return_url=%2F</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">支付服务</td>
            <td style="width: 210px;">支付宝支付</td>
            <td style="width: 410px;">为用户充值提供快捷支付功能</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">设备MAC地址</td>
            <td style="width: 458px;">采取去标识化处理</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://open.alipay.com/platform/home.htm?from=wwwalipay" style="color: #6C63B9 ">https://open.alipay.com/platform/<br />home.htm?from=wwwalipay<br />home/login?return_url=%2F</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">支付服务</td>
            <td style="width: 210px;">威富通支付SDK</td>
            <td style="width: 410px;">为用户充值提供快捷支付功能</td>
            <td style="width: 330px;">嵌入该SDK，SDK将收集传输<br />个人信息</td>
            <td style="width: 330px;">设备MAC地址</td>
            <td style="width: 458px;">采取去标识化处理</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://www.swiftpass.cn/cooperation/apply/page.html" style="color: #6C63B9 ">https://www.swiftpass.cn<br />/cooperation/apply/page.html</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">音频视频服务</td>
            <td style="width: 210px;">声网SDK</td>
            <td style="width: 410px;">为直播提供音视频推拉流服务</td>
            <td style="width: 330px;">嵌入该SDK</td>
            <td style="width: 330px;">摄像头信息，麦克风信息，设<br />备类型，设备型号，CPU信<br />息，存储信息，电池电量信<br />息，操作系统信息</td>
            <td style="width: 458px;">采取去标识化处理</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://www.shuzilm.cn/main/" style="color: #6C63B9 ">https://www.shuzilm.cn/main/</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">音频视频服务</td>
            <td style="width: 210px;">金山云推流sdk</td>
            <td style="width: 410px;">为直播提供音视频推拉流服务</td>
            <td style="width: 330px;">嵌入该SDK</td>
            <td style="width: 330px;">摄像头信息，麦克风信息，设<br />备类型，设备型号，CPU信<br />息，存储信息，电池电量信<br />息，操作系统信息</td>
            <td style="width: 458px;">采取去标识化处理</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://docs.ksyun.com/documents/1068" style="color: #6C63B9 ">https://docs.ksyun.com/documents/1068</a></td>
        </tr>
        <tr style="text-align: center; color: #302E3E; font-size: 22px">
            <td style="width: 170px;">音频视频服务</td>
            <td style="width: 210px;">金山云播放sdk</td>
            <td style="width: 410px;">为直播提供音视频推拉流服务</td>
            <td style="width: 330px;">嵌入该SDK</td>
            <td style="width: 330px;">摄像头信息，麦克风信息，设<br />备类型，设备型号，CPU信<br />息，存储信息，电池电量信<br />息，操作系统信息</td>
            <td style="width: 458px;">采取去标识化处理</td>
            <td style="width: 420px; color:#6C63B9 "><a href="https://docs.ksyun.com/documents/486" style="color: #6C63B9 ">https://docs.ksyun.com/documents/486</a></td>
        </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Sdk'
}
</script>
